import React from 'react';
import { motion } from 'framer-motion';
import Navigation from './Navigation';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const Header: React.FC = () => {
    const { scrollPosition } = useScrollAnimation();
    const isScrolled = scrollPosition.y > 50;

    return (
        <motion.header
            className="fixed top-0 left-0 right-0 z-50"
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
        >
            <Navigation />

            {/* Scroll Shadow */}
            <motion.div
                className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"
                initial={{ opacity: 0 }}
                animate={{ opacity: isScrolled ? 1 : 0 }}
                transition={{ duration: 0.3 }}
            />
        </motion.header>
    );
};

export default Header;